'use client';

import { useTranslation } from '@/hooks/useTranslation';
import { salesOrderApi, type SalesOrder } from '../_lib/api';
import { Badge, SimpleListPage } from '../_lib/SimpleListPage';

const SO_STATUS_COLORS: Record<string, { bg: string; text: string }> = {
  RESERVED: { bg: '#fff8e6', text: '#d4a017' },
  PENDING: { bg: '#fff7e8', text: '#ff7d00' },
  APPROVED: { bg: '#e6fff0', text: '#0fc66e' },
  FULFILLING: { bg: '#e8f3ff', text: '#3370ff' },
  COMPLETED: { bg: '#f7f8fa', text: '#8f959e' },
  CANCELLED: { bg: '#ffece8', text: '#f53f3f' },
};

const CONTRACT_COLORS: Record<string, { bg: string; text: string }> = {
  DRAFT: { bg: '#f0f0f0', text: '#888' },
  SIGNED: { bg: '#e6fff0', text: '#0fc66e' },
  VOID: { bg: '#ffece8', text: '#f53f3f' },
};

export default function SalesOrdersPage() {
  const { t } = useTranslation();
  const rm = t.robotManager;
  return (
    <SimpleListPage<SalesOrder>
      title={rm.lists.salesOrders.title}
      description={rm.lists.salesOrders.description}
      load={async (p) => (await salesOrderApi.list(p)).items}
      searchPlaceholder={rm.lists.salesOrders.searchPlaceholder}
      columns={[
        { key: 'soNo', label: rm.fields.soNo, width: '180px' },
        { key: 'd365SoId', label: rm.fields.d365SoId, width: '160px' },
        { key: 'contractStatus', label: rm.fields.contractStatus, width: '100px', render: (s) => {
          const c = CONTRACT_COLORS[s.contractStatus] ?? { bg: '#f0f0f0', text: '#888' };
          return <Badge text={s.contractStatus} bg={c.bg} color={c.text} />;
        } },
        { key: 'status', label: rm.fields.status, width: '120px', render: (s) => {
          const c = SO_STATUS_COLORS[s.status] ?? { bg: '#f0f0f0', text: '#888' };
          return <Badge text={s.status} bg={c.bg} color={c.text} />;
        } },
        { key: 'totalAmount', label: rm.fields.amount, width: '140px', render: (s) => `${s.currencyCode} ${Number(s.totalAmount).toLocaleString()}` },
        { key: 'signedAt', label: rm.fields.signedAt, render: (s) => s.signedAt ? new Date(s.signedAt).toLocaleDateString() : '-' },
        { key: 'createdAt', label: rm.fields.createdShort, render: (s) => new Date(s.createdAt).toLocaleDateString() },
      ]}
    />
  );
}
